import { MarketingLayout } from '../../layouts/MarketingLayout';

const sections = [
  {
    heading: '1. Information we collect',
    body: 'We collect the information you provide directly (display name, email, profile data), information generated when you use Keskedo (signed identity events, governance votes, device data), and information from third parties such as identity providers and partner apps you connect.',
  },
  {
    heading: '2. How we use your information',
    body: 'We use your information to operate Keskedo, authenticate you across the ecosystem, comply with legal obligations, prevent fraud, communicate with you about your account, and improve our products. We do not sell personal information.',
  },
  {
    heading: '3. Sharing your information',
    body: 'We share information only with service providers who help us operate Keskedo, with regulators and law enforcement when required by law, and with apps in the ecosystem that you have explicitly granted access to.',
  },
  {
    heading: '4. International transfers',
    body: 'Keskedo operates globally. Your information may be transferred to and processed in countries other than your own. When we transfer personal data out of the EEA or UK, we rely on appropriate safeguards such as Standard Contractual Clauses.',
  },
  {
    heading: '5. Data retention',
    body: 'We retain personal data for as long as your account is active and as required to comply with our legal obligations. Specific retention periods are documented in our Trust Center.',
  },
  {
    heading: '6. Your rights',
    body: 'Depending on your jurisdiction, you have rights to access, correct, delete, or port your personal data, and to object to or restrict certain processing. To exercise these rights, contact privacy@keskedo.com.',
  },
  {
    heading: '7. Security',
    body: 'We protect your information with end-to-end encryption, WebAuthn-based authentication, network segmentation, and continuous security monitoring. No system is perfectly secure, but we work hard to make ours as close as possible.',
  },
  {
    heading: '8. Contact',
    body: 'Questions about this policy can be sent to privacy@keskedo.com or by post to Keskedo Ecosystem Inc., 14 Old Street, London EC1V 9BG, United Kingdom.',
  },
];

export const Privacy = () => {
  return (
    <MarketingLayout
      title="Privacy Policy"
      subtitle="Last updated: 2026-04-01. This policy explains what data we collect, why, and what choices you have."
    >
      <article className="space-y-8">
        <p className="text-slate-600 leading-relaxed">
          Your privacy matters to us. This Privacy Policy describes how Keskedo Ecosystem Inc. ("Keskedo", "we", "us")
          collects, uses, and protects your personal information when you use our services.
        </p>
        {sections.map((s, i) => (
          <section key={i} className="space-y-3">
            <h2 className="text-xl font-bold text-slate-900">{s.heading}</h2>
            <p className="text-slate-600 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </article>
    </MarketingLayout>
  );
};
